var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-dashboard__text pc-section-dashboard-intro-style-1"},[_c('text-body-extra-small',{staticClass:"pc-dashboard__text-description",attrs:{"line-height":'multi'},domProps:{"innerHTML":_vm._s(_vm.elements)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }